import React, { useEffect, useState } from 'react';
import Modal from '../index';

import FillCPF from '../InfoToModal/FillCPF';
import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../../store/analytic/actions';
interface IScheduleCall {
  handlerClose: () => void;
  verification: string;
}

const ScheduleCallModal: React.FC<IScheduleCall> = (props) => {
  const [title, setTitle] = useState('Agendar uma ligação');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/abreAgendarLigacao',
      }),
    );
  }, [dispatch]);

  const handleChangeTitle = () => {
    setTitle('');
  };

  return (
    <Modal
      title={title}
      handlerClose={props.handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
    >
      <FillCPF
        title={'Preencha seu CPF abaixo para que possamos saber quem você é:'}
        subtitle={'Seu CPF'}
        handlerClose={props.handlerClose}
        changeTitle={handleChangeTitle}
        textbtn={'AGENDAR'}
        text2btn={''}
        type={''}
        verification={props.verification}
        details={{
          title: 'Agendamento concluído!',
          subtitle:
            'No horário escolhido, aguarde que um de nossos operadores entrará em contato.',
          detail: 'Detalhes do agendamento:',
          datehour: '05/11/2020 às 09:15',
        }}
      />
    </Modal>
  );
};

export default ScheduleCallModal;
